import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';

export const syncDataApi = createApi({
  reducerPath: 'syncDataApi',
  baseQuery,
  endpoints: (builder) => ({
    syncData: builder.mutation({
      query: () => ({
        url: '/sync-data',
        method: 'GET',
      }),
      invalidatesTags: ['SyncData'],
    }),

    runPython: builder.mutation({
      query: () => ({
        url: '/street_rates/run-python',
        method: 'POST',
      }),
      invalidatesTags: ['SyncData'],
    }),
  }),
});

export const { useSyncDataMutation, useRunPythonMutation } = syncDataApi;
